import React, { useState } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";

import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";

import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit";
const { ExportCSVButton } = CSVExport;

import filterFactory, { textFilter } from "react-bootstrap-table2-filter";

// const { SearchBar } = Search;

import { Row, Col, Button, Form, FormControl } from "react-bootstrap";

//Import ConfirmAlert
import { confirmAlert } from "react-confirm-alert";

import FarmerService from "../../services/farmer.service";

//Import Modal
import ModaladdFarmer from "./ModaladdFarmer";
import ModaleditFarmer from "./ModaleditFarmer";

//Import Loading
import LoadingAlert from "../../components/LoadingAlert";

import "./farmer.css";

function Farmerlist() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [show_add, setShow_add] = useState(false);
  const [show_edit, setShow_edit] = useState(false);
  const [selectFarmerId, setSelectFarmerId] = useState(0);
  const [textSearch, setTextSearch] = useState("");

  const user = JSON.parse(sessionStorage.getItem("user"));

  // useEffect(() => {
  //   getData();
  // }, []);

  const getData = () => {
    setLoading(true);
    FarmerService.getFarmerSearch({ textSearch: textSearch })
      .then((response) => {
        setData(response.data.data);
      })
      .catch((error) => {
        console.error("error fetching data: ", error);
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const clickDelete = (row) => {
    confirmAlert({
      title: "",
      message: "ต้องการลบใช่หรือไม่",
      buttons: [
        {
          label: "ใช่",
          onClick: () => {
            setLoading(true);
            FarmerService.deleteFarmer(row.farmer_id)
              .then((response) => {
                if (response.data.success) {
                  // setShow_delete(false);
                  // alert(response.data.message);
                  setData((data) =>
                    data.filter((a) => a.farmer_id != row.farmer_id)
                  );
                } else {
                  alert(response.data.message);
                }
              })
              .catch((error) => {
                console.error("error delete", error);
              })
              .finally(() => {
                setLoading(false);
              });
          },
        },
        {
          label: "ไม่ใช่",
          onClick: () => false,
        },
      ],
      overlayClassName: "confirm-alert-custom",
    });
  };
  // const handleSearch = (e) => {
  //   e.preventDefault();
  // };

  const handleSearchChange = (e) => {
    setTextSearch(e.target.value);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    getData();
  };

  const clickEdit = (id) => {
    setShow_edit(true);
    setSelectFarmerId(id);
  };
  const ActionsEdit = (row) => {
    return (
      <>
        <i
          className="bi bi-pencil custom-icon-table"
          onClick={() => clickEdit(row.row.farmer_id)}
        ></i>
        <i
          className="bi bi-trash custom-icon-table"
          style={{ color: "red" }}
          onClick={() => clickDelete(row.row)}
        ></i>
      </>
    );
  };

  const actionsEdittFormatter = (cell, row) => {
    return <ActionsEdit row={row} />;
  };

  const columns = [
    {
      text: "ID",
      dataField: "farmer_id",
      sort: true,
      // filter: textFilter({ placeholder: "ค้นหา" }),
      hidden: true,
      csvExport: false,
    },
    {
      text: "ชื่อ-สกุล",
      dataField: "fullname",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "20%" };
      },
      style: {
        textAlign: "left",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "บัตรประชาชน",
      dataField: "farmer_idcard",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "20%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "center",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "ที่อยู่",
      dataField: "fulladdress",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "35%" };
      },
      style: {
        textAlign: "left",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },

    {
      text: "เพศ",
      dataField: "farmer_gender",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "center",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "สถานะ",
      dataField: "farmer_status_text",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "center",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "แก้ไข",
      dataField: "edit",
      isDummyField: true,
      editable: false,
      formatter: actionsEdittFormatter,
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "center",
      },
      csvExport: false,
    },
  ];

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 5,
    firstPageText: "|<",
    lastPageText: ">|",
    nextPageText: ">>",
    prePageText: "<<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
    onSizePerPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
  });

  const handleClickAdd = () => {
    setShow_add(true);
  };

  if (error) return `Error :${error}`;

  return (
    <div>
      {loading ? <LoadingAlert /> : ""}

      <ModaladdFarmer
        show={show_add}
        hidden={(a) => setShow_add(a)}
        data={data}
        setdata={(a) => setData(a)}
      />
      <ModaleditFarmer
        show={show_edit}
        hidden={(a) => setShow_edit(a)}
        data={data}
        setdata={(a) => setData(a)}
        farmer_id={selectFarmerId}
      />
      <ToolkitProvider
        bootstrap4
        keyField="farmer_id"
        data={data}
        columns={columns}
        search
        width={100}
        exportCSV={{
          fileName: "ข้อมูลพื้นฐานเกษตรกร.csv", // "ข้อมูลสมาชิก_" + {cell} + ".csv",
          separator: ",",
          ignoreHeader: false,
          noAutoBOM: false,
          blobType: "text/plain;charset=utf-8",
          onlyExportFiltered: true,
          exportAll: false,
        }}
      >
        {(prop) => (
          <React.Fragment>
            <Row>
              <Col md={6}>
                <Form className="d-flex">
                  <FormControl
                    size="sm"
                    type="search"
                    placeholder="ค้นหาด้วย ชื่อ,นามสกุล,บัตรประชาชน"
                    className="me-2"
                    aria-label="Search"
                    onChange={handleSearchChange}
                  />
                  <Button
                    variant="info"
                    onClick={handleSearch}
                    style={{ margin: 0 }}
                  >
                    ค้นหา
                  </Button>
                </Form>
              </Col>
              <Col md={6}>
                <div style={{ textAlign: "right" }}>
                  <Button
                    className="btn btn-primary"
                    onClick={handleClickAdd}
                    style={{
                      padding: ".375rem .75rem",
                      fontSize: "1rem",
                      marginRight: "0 1rem !important",
                    }}
                  >
                    เพิ่มข้อมูลพื้นฐานเกษตรกร
                  </Button>{" "}
                  {user.user.member_type === 6 ? (
                    <ExportCSVButton
                      {...prop.csvProps}
                      style={{
                        padding: ".375rem .75rem",
                        fontSize: "1rem",
                        float: "right",
                      }}
                    >
                      <i className="bi bi-download"></i>
                    </ExportCSVButton>
                  ) : (
                    ""
                  )}
                </div>
              </Col>
            </Row>

            <BootstrapTable
              // bootstrap4
              // keyField="farmer_id"
              // columns={columns}
              // data={data}
              pagination={pagination}
              //   cellEdit={cellEditFactory({
              //     mode: "click",
              //     blurToSave: true,
              //     afterSaveCell,
              //   })}
              filter={filterFactory()}
              // loading={true}
              {...prop.baseProps}
              // cellEdit={cellEditFactory({
              //   mode: "click",
              //   blurToSave: true,
              //   afterSaveCell: handleChange,
              //   beforeSaveCell: beforeSaveCell,
              // })}
            />
          </React.Fragment>
        )}
      </ToolkitProvider>
    </div>
  );
}

export default Farmerlist;
